import { DistributionDto } from '@/models/suba/distributions/DistributionDto.model';
import ApiService from '@/services/Api.service';

export class DistributionService {
  static async getByTracerId(tracerId: string) {
    return ApiService.getJson<DistributionDto>(`/distributions/${tracerId}`);
  }
}
